const ItemTitle = ({ title, subTitle }: any) => {
  if (!subTitle) return null;
  return (
    <div className="flex items-center gap-2 bg-white px-4 py-1 rounded-lg">
      <p className="text-[#75757E]  text-sm capitalize ">{title} </p>
      <span className="text-color-primary  text-sm capitalize ">
        {subTitle}
      </span>
    </div>
  );
};

export default ItemTitle;
